export default "__VITE_ASSET__Tx68hqyB__"